// ============================================================
// Contenus juridiques ASTROLOG
// Modèle à faire relire par un conseil juridique avant publication.
// ============================================================
import { COMPANY } from "@/config/site";

export const LEGAL_UPDATE = "Dernière mise à jour : juillet 2025";

export const MENTIONS_LEGALES = {
  title: "Mentions légales",
  seo: "Mentions légales du site astrolog.business — ASTROLOG SAS, RCS Troyes 917 559 247, hébergement Namecheap.",
  sections: [
    {
      h: "1. Éditeur du site",
      paragraphs: [
        `${COMPANY.name}, Société par Actions Simplifiée (SAS) au capital de ${COMPANY.capital}, immatriculée au Registre du Commerce et des Sociétés de Troyes sous le numéro ${COMPANY.siren} (SIRET siège : ${COMPANY.siret}).`,
        `Siège social : ${COMPANY.fullAddress}.`,
        `Code APE / NAF : ${COMPANY.ape}. Numéro de TVA intracommunautaire : ${COMPANY.tva}.`,
        `Téléphone : ${COMPANY.phone} — Email : ${COMPANY.email}.`,
      ],
    },
    {
      h: "2. Directeur de la publication",
      paragraphs: [`${COMPANY.publicationDirector}.`],
    },
    {
      h: "3. Hébergement",
      paragraphs: [
        `${COMPANY.host.name} — ${COMPANY.host.address} — Téléphone : ${COMPANY.host.phone} — Site : ${COMPANY.host.site}.`,
      ],
    },
    {
      h: "4. Propriété intellectuelle",
      paragraphs: [
        "L'ensemble des contenus du site (textes, logos, éléments graphiques, photographies, structure) est la propriété exclusive d'ASTROLOG ou fait l'objet d'une autorisation d'utilisation. Toute reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite et constituerait une contrefaçon au sens des articles L.335-2 et suivants du Code de la propriété intellectuelle.",
      ],
    },
    {
      h: "5. Données personnelles",
      paragraphs: [
        "Les traitements de données personnelles réalisés depuis ce site sont décrits dans la politique de confidentialité, accessible depuis le pied de page de chaque page.",
      ],
    },
    {
      h: "6. Cookies",
      paragraphs: [
        "Le site utilise des cookies strictement nécessaires à son fonctionnement et, sous réserve de votre consentement, des cookies de mesure d'audience. Vous pouvez modifier votre choix à tout moment via le lien « Gérer mes cookies » en pied de page.",
      ],
    },
    {
      h: "7. Liens hypertextes",
      paragraphs: [
        "Les liens vers des sites tiers ne sont fournis qu'à titre d'information ; ASTROLOG n'exerce aucun contrôle sur leur contenu et décline toute responsabilité à leur égard. La mise en place de liens vers ce site est autorisée sous réserve qu'ils ne portent pas atteinte à l'image de la société.",
      ],
    },
    {
      h: "8. Droit applicable",
      paragraphs: [
        "Le présent site est soumis au droit français. En cas de litige, et à défaut de solution amiable, compétence est attribuée aux tribunaux compétents de Troyes, sous réserve des règles légales impératives applicables aux consommateurs.",
      ],
    },
  ],
};

export const CGV = {
  title: "Conditions générales de vente",
  seo: "Conditions générales de prestation de transport ASTROLOG : devis, prix, paiement, exécution, responsabilité, réclamations et médiation.",
  sections: [
    {
      h: "1. Objet et champ d'application",
      paragraphs: [
        "Les présentes conditions générales de vente (CGV) régissent l'ensemble des prestations de transport routier de marchandises, de location de véhicules industriels avec conducteurs, de déménagement et de commission de transport fournies par ASTROLOG, SAS au capital de 75 000,00 €, RCS Troyes 917 559 247, à tout client particulier ou professionnel.",
        "Toute commande implique l'acceptation sans réserve des présentes CGV, qui prévalent sur tout autre document, sous réserve des conditions particulières convenues par écrit.",
      ],
    },
    {
      h: "2. Devis et commande",
      paragraphs: [
        "Le devis est établi gratuitement et est valable 15 jours à compter de sa date d'émission. La commande devient ferme après acceptation écrite du devis par le client (signature ou accord exprès par courrier électronique).",
        "Le consommateur particulier dispose, pour les contrats conclus à distance ou hors établissement, d'un droit de rétractation de 14 jours conformément à l'article L.221-18 du Code de la consommation, sous réserve des exceptions légales (notamment l'exécution pleine et entière de la prestation avant l'expiration du délai avec renonciation expresse au droit de rétractation).",
      ],
    },
    {
      h: "3. Prix",
      paragraphs: [
        "Les prix sont exprimés en euros hors taxes (HT). La TVA applicable au transport est de 20 % (taux normal) ; le taux applicable est précisé sur chaque devis.",
        "Le prix est déterminé en fonction de la distance, du poids et du volume de la marchandise, du type de véhicule, des options retenues, des conditions d'accès et des délais. Toute modification des éléments ayant servi à l'établissement du devis peut donner lieu à un devis complémentaire soumis à l'accord du client.",
      ],
    },
    {
      h: "4. Modalités de paiement",
      paragraphs: [
        "Un acompte de 30 % est exigé à la commande ; le solde est payable à la livraison, par virement bancaire ou carte bancaire. Pour les professionnels, le paiement par virement à 30 jours fin de mois peut être consenti sur accord préalable.",
        "En cas de retard de paiement, sont exigibles de plein droit des pénalités au taux légal majoré ainsi qu'une indemnité forfaitaire de recouvrement de 40 €, conformément aux articles L.441-10 et D.441-5 du Code de commerce, sans préjudice de l'indemnisation complémentaire des frais de recouvrement engagés.",
      ],
    },
    {
      h: "5. Exécution du transport",
      paragraphs: [
        "Le transporteur s'engage à exécuter la prestation avec le soin et la diligence professionnels, dans les délais convenus. Le donneur d'ordre s'engage à déclarer exactement la nature, le poids et le volume de la marchandise, à assurer un emballage adapté et à signaler toute condition d'accès particulière (étage, ascenseur, zone à circulation restreinte).",
        "Les matières dangereuses ne sont pas prises en charge, sauf accord écrit préalable. Les temps d'attente au-delà de deux heures sur les lieux d'enlèvement ou de livraison sont facturés en sus selon le barème communiqué sur devis.",
      ],
    },
    {
      h: "6. Responsabilité",
      paragraphs: [
        "La responsabilité du transporteur est régie par les articles L.133-1 et suivants du Code de commerce. L'indemnisation des pertes et avaries est limitée à 33 € par kilogramme de poids brut manquant ou avarié, sauf déclaration de valeur ou intérêt particulier à la livraison formulée par le donneur d'ordre et acceptée par le transporteur.",
        "Sont exclus de la prise en charge, sauf accord préalable écrit : bijoux, valeurs, objets d'art, documents, animaux vivants, ainsi que toute marchandise prohibée ou réglementée.",
      ],
    },
    {
      h: "7. Assurance",
      paragraphs: [
        "ASTROLOG est titulaire d'une assurance responsabilité civile professionnelle et d'une assurance marchandises transportées souscrite auprès d'AXA France IARD, couvrant la France métropolitaine et l'Union européenne. Une attestation est fournie sur simple demande. Une assurance ad valorem peut être souscrite sur demande du client.",
      ],
    },
    {
      h: "8. Réclamations",
      paragraphs: [
        "Toute réclamation relative à la prestation doit être formulée par écrit dans un délai de trois (3) jours à compter de la réception des marchandises, conformément à l'article L.133-3 du Code de commerce, les réserves précises et motivées devant figurer sur le document de transport à la livraison.",
      ],
    },
    {
      h: "9. Force majeure",
      paragraphs: [
        "Aucune des parties ne saurait être tenue responsable d'un manquement à ses obligations résultant d'un événement de force majeure au sens de l'article 1218 du Code civil.",
      ],
    },
    {
      h: "10. Confidentialité",
      paragraphs: [
        "Les parties s'engagent à préserver la confidentialité des informations commerciales et techniques échangées dans le cadre de la prestation, pendant sa durée et après son terme.",
      ],
    },
    {
      h: "11. Résiliation",
      paragraphs: [
        "En cas de manquement grave de l'une des parties à ses obligations, non réparé dans un délai de quinze jours après mise en demeure, l'autre partie peut résoudre la commande sans préjudice de dommages et intérêts. Toute annulation par le client après acceptation du devis peut donner lieu à la retenue de l'acompte et à la facturation des frais engagés.",
      ],
    },
    {
      h: "12. Données personnelles",
      paragraphs: [
        "Les données personnelles collectées dans le cadre des prestations sont traitées conformément à la politique de confidentialité disponible sur le site, en application du Règlement (UE) 2016/679 et de la loi Informatique et Libertés.",
      ],
    },
    {
      h: "13. Réclamation et médiation",
      paragraphs: [
        `${COMPANY.mediator.name}, ${COMPANY.mediator.address} — Tél. : ${COMPANY.mediator.phone} — Email : ${COMPANY.mediator.email} — Site : ${COMPANY.mediator.site}.`,
        "Le client consommateur peut recourir gratuitement à ce médiateur pour tout litige de consommation non résolu. Pour les clients professionnels, un règlement amiable préalable sera recherché avant toute saisine des tribunaux compétents de Troyes.",
      ],
    },
    {
      h: "14. Droit applicable",
      paragraphs: [
        "Les présentes CGV sont soumises au droit français.",
      ],
    },
    {
      h: "15. Entrée en vigueur et mise à jour",
      paragraphs: [
        `Les présentes conditions entrent en vigueur à la date de leur publication et peuvent être mises à jour à tout moment. ${LEGAL_UPDATE}.`,
      ],
    },
  ],
};

export const CGU = {
  title: "Conditions générales d'utilisation",
  seo: "Conditions générales d'utilisation du site astrolog.business : accès, contenus, propriété intellectuelle, responsabilité.",
  sections: [
    {
      h: "1. Objet",
      paragraphs: [
        "Les présentes conditions générales d'utilisation (CGU) encadrent l'accès et l'utilisation du site astrolog.business, édité par ASTROLOG, SAS au capital de 75 000,00 €, RCS Troyes 917 559 247.",
      ],
    },
    {
      h: "2. Acceptation",
      paragraphs: [
        "La navigation sur le site vaut acceptation pleine et entière des présentes CGU. L'utilisateur qui ne les accepte pas est invité à quitter le site.",
      ],
    },
    {
      h: "3. Accès au site",
      paragraphs: [
        "Le site est accessible 24 h/24 et 7 j/7, sauf interruption pour maintenance ou cas de force majeure. ASTROLOG ne saurait être tenue responsable des interruptions de service indépendantes de sa volonté.",
      ],
    },
    {
      h: "4. Contenu informatif",
      paragraphs: [
        "Les informations publiées, notamment les résultats du calculateur d'estimation, sont fournies à titre indicatif et ne constituent ni un devis ni une offre contractuelle. Seul un devis écrit émis par ASTROLOG fait foi.",
      ],
    },
    {
      h: "5. Utilisation autorisée",
      paragraphs: [
        "L'utilisateur s'engage à utiliser le site de manière loyale, à ne pas tenter d'en perturber le fonctionnement, à ne pas collecter de données à des fins commerciales non autorisées et à ne pas transmettre de contenu illicite via les formulaires.",
      ],
    },
    {
      h: "6. Propriété intellectuelle",
      paragraphs: [
        "Tous les contenus du site sont protégés. Toute reproduction ou représentation sans autorisation écrite est interdite.",
      ],
    },
    {
      h: "7. Liens hypertextes",
      paragraphs: [
        "ASTROLOG n'est pas responsable du contenu des sites tiers accessibles par des liens présents sur le site.",
      ],
    },
    {
      h: "8. Données personnelles et cookies",
      paragraphs: [
        "L'utilisation du site implique les traitements décrits dans la politique de confidentialité. La gestion des cookies s'effectue via le lien « Gérer mes cookies » en pied de page.",
      ],
    },
    {
      h: "9. Responsabilité",
      paragraphs: [
        "ASTROLOG met en œuvre les moyens raisonnables pour assurer l'exactitude des informations diffusées, sans pouvoir en garantir l'absence d'erreurs ou d'omissions. Sa responsabilité ne saurait être engagée pour les dommages indirects liés à l'utilisation du site.",
      ],
    },
    {
      h: "10. Modification",
      paragraphs: [
        `ASTROLOG se réserve le droit de modifier les présentes CGU à tout moment. ${LEGAL_UPDATE}.`,
      ],
    },
    {
      h: "11. Droit applicable",
      paragraphs: [
        "Les présentes CGU sont soumises au droit français. Tout litige relève des tribunaux compétents de Troyes, sous réserve des règles impératives applicables aux consommateurs.",
      ],
    },
  ],
};

export const CONFIDENTIALITE = {
  title: "Politique de confidentialité",
  seo: "Politique de confidentialité ASTROLOG : données collectées, finalités, durées de conservation, droits RGPD, cookies.",
  sections: [
    {
      h: "1. Responsable de traitement",
      paragraphs: [
        `ASTROLOG, SAS au capital de ${COMPANY.capital}, ${COMPANY.fullAddress}, RCS Troyes 917 559 247. Contact : ${COMPANY.email}.`,
      ],
    },
    {
      h: "2. Données collectées",
      paragraphs: [
        "Via les formulaires de devis et de contact : profil (particulier/professionnel), type de prestation, société, nom et prénom, email, téléphone, adresses d'enlèvement et de livraison, date souhaitée, nature de la marchandise, poids, volume, options, informations complémentaires, photos ou documents transmis.",
        "Via le calculateur d'estimation : adresses de départ et d'arrivée, poids, type de véhicule, options. Ces données servent au calcul effectué dans votre navigateur et ne nous sont transmises que si vous envoyez une demande de devis.",
        "Via la navigation : adresse IP, journaux de connexion, type de navigateur.",
      ],
    },
    {
      h: "3. Finalités et bases légales",
      paragraphs: [
        "Réponse aux demandes de devis et exécution de mesures précontractuelles (article 6.1.b du RGPD) et intérêt légitime (article 6.1.f).",
        "Exécution du contrat de transport et respect des obligations légales (facturation, sécurité, douane).",
        "Prospection commerciale, avec votre consentement ou sur le fondement de l'intérêt légitime pour les clients professionnels.",
        "Sécurité du site et respect des obligations comptables et fiscales.",
      ],
    },
    {
      h: "4. Durées de conservation",
      paragraphs: [
        "Devis non aboutis : 3 ans. Clients : durée de la relation puis 10 ans à des fins comptables. Prospection : 3 ans. Photos et documents transmis : durée nécessaire à l'instruction du devis puis suppression au plus tard sous 3 ans, ou sur demande. Cookies : 13 mois maximum. Journaux techniques : 12 mois maximum.",
      ],
    },
    {
      h: "5. Destinataires et sous-traitants",
      paragraphs: [
        "Les données sont destinées au président d'ASTROLOG et aux personnes habilitées. Sous-traitants : l'hébergeur Namecheap (États-Unis) et le prestataire de messagerie. Des partenaires transporteurs peuvent être destinataires, avec votre accord préalable.",
        "L'hébergement aux États-Unis implique un transfert hors Union européenne encadré par des clauses contractuelles types de la Commission européenne et/ou par le Data Privacy Framework.",
      ],
    },
    {
      h: "6. Vos droits",
      paragraphs: [
        `Vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition, de portabilité et de retrait du consentement. Pour les exercer : ${COMPANY.email}.`,
        "Vous pouvez introduire une réclamation auprès de la CNIL : cnil.fr — 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07.",
      ],
    },
    {
      h: "7. Cookies",
      paragraphs: [
        "Le site utilise des cookies strictement nécessaires et, avec votre consentement, des cookies de mesure d'audience. Le bandeau de consentement vous permet d'accepter, de refuser ou de personnaliser, avec une égale visibilité des choix et aucune case pré-cochée. Vous pouvez retirer votre consentement à tout moment via « Gérer mes cookies » en pied de page.",
      ],
    },
    {
      h: "8. Sécurité",
      paragraphs: [
        "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées : chiffrement HTTPS, contrôle des accès, sauvegardes régulières et sécurisation des documents transmis.",
      ],
    },
    {
      h: "9. Mineurs",
      paragraphs: [
        "Le site et les services d'ASTROLOG s'adressent exclusivement à des personnes majeures.",
      ],
    },
    {
      h: "10. Modification",
      paragraphs: [
        `La présente politique peut être mise à jour à tout moment. ${LEGAL_UPDATE}.`,
      ],
    },
    {
      h: "11. Contact",
      paragraphs: [
        `Pour toute question relative à vos données personnelles : ${COMPANY.email} — ${COMPANY.phone} — ${COMPANY.fullAddress}.`,
      ],
    },
  ],
};
